import React from 'react';
import logo from '../../images/logo1.svg';
import SelectLanguage from 'components/SelectLanguage/SelectLanguage';
import LearningPlatform from 'components/LearningPlatform/LearningPlatform';

import LearningLogo from '../../images/training.svg';
import Salesman from '../../images/salesman.svg';
import translate from 'i18n/translate';
import { Link } from 'react-router-dom';

export default function Topbar() {
  return (
    <div className="topbar-container">
      <div className="topbar center-container">
        <div className="topbar-logo">
          <Link to="/">
            <img alt="topbar-logo" src={logo}></img>
          </Link>

          {/* <h2>{translate('test', { label: <b>dobar</b> })}</h2> */}
        </div>
        <div className="learning-platforms d-flex justify-content-between">
          <LearningPlatform
            text={translate('vmcAcademy')}
            subtitle={translate('ePlatform')}
            logo={LearningLogo}
            link="https://knowledge.web021.net/"
          ></LearningPlatform>
          <LearningPlatform
            text={translate('vmcInovationHub')}
            logo={Salesman}
            link="https://bpowesternbalkans.com/"
          ></LearningPlatform>
        </div>
        <SelectLanguage></SelectLanguage>
      </div>
    </div>
  );
}
